import { CancelToken } from 'axios';
import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useUser } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODUrlRequestParams, IVODUrlResponse } from '~/Models/DTO/VideoOnDemand.models';

export const useRequestVideoUrl = (cancelToken?: CancelToken) => {
  const { currentUser } = useUser();
  const {
    data: videoUrlResponse,
    error: videoUrlError,
    isLoading: isVideoUrlLoading,
    mutate: getVideoUrl,
    isSuccess: isVideoUrlSuccess,
  } = useMutation<IVODUrlResponse, IErrorResponse, IVODUrlRequestParams>(
    async (params: IVODUrlRequestParams) =>
      requestReactQuery<IVODUrlResponse>({
        url: VIDEO_INTEGRATION_SERVICE_URLS.VOD_VIDEOS_URL,
        data: {
          videoId: params.videoId,
          userId: currentUser?.uuid,
          orderLineId: params?.orderLineId,
        },
        config: { method: 'POST', cancelToken },
      }),
    {
      mutationKey: REQUEST_ACTIONS.GET_VOD_VIDEO_URL,
      retry(failureCount) {
        if (failureCount < 15) {
          return true;
        }
        return false;
      },
      retryDelay: 5000,
    },
  );

  return {
    videoUrlError: videoUrlError as IErrorResponse,
    videoUrlResponse,
    getVideoUrl,
    isVideoUrlLoading,
    isVideoUrlSuccess,
  };
};
